module.exports = __webpack_public_path__ + "img/cadastro_xp_ontick-01.3db2ea24.png";